import React from 'react';
import PropTypes from 'prop-types';

import { ToolTip } from './ToolTip';
import { Circle } from './Circle';

export class Error extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false
    };
  }

  hideToolTip() {
    this.setState({ showTooltip: false });
  }

  revealToolTip() {
    this.setState({ showTooltip: true });
  }
  render() {
    const { showTooltip } = this.state;
    const { wrapperStyle, toolTipStyle } = this.props;

    let tooltip = null;
    if (showTooltip === true) {
      tooltip = <ToolTip wrapperStyle={toolTipStyle}>{this.props.message}</ToolTip>;
    }

    return (
      <div
        style={wrapperStyle}
        onMouseOut={this.hideToolTip.bind(this)}
        onMouseOver={this.revealToolTip.bind(this)}
      >
        {tooltip}
        <Circle />
      </div>
    );
  }
}

Error.defaultProps = {
  toolTipStyle: {},
  wrapperStyle: {}
};

Error.propTypes = {
  toolTipStyle: PropTypes.object,
  wrapperStyle: PropTypes.object
};
